import { render } from "./List3.vue?vue&type=template&id=385b2c8d&scoped=true"
import script from "./List3.vue?vue&type=script&lang=js"
export * from "./List3.vue?vue&type=script&lang=js"

import "./List3.vue?vue&type=style&index=0&id=385b2c8d&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385b2c8d"]])

export default __exports__